import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DepartmentAddEditComponent, DepartmentModel, UserModuleApiSuffixModels } from '@app/modules/user';
import { AppState } from '@app/reducers';
import { CrudService, CrudType, IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix, ReusablePrimeNGTableFeatureService, RxjsService, SnackbarService, addDefaultTableObjectProperties, checkUserPermissionsByCategory, currentComponentPageBasedPermissionsSelector$, onActionSubmittedUtil, prepareDynamicTableTabsFromPermissions, prepareGetRequestHttpParams } from '@app/shared';
import { loggedInUserData } from '@modules/others';
import { IT_MANAGEMENT_COMPONENT } from '@modules/user/shared';
import { Store } from '@ngrx/store';
import { DialogService } from 'primeng/api';
import { combineLatest } from 'rxjs';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
@Component({
  selector: 'app-department-list',
  templateUrl: './department-list.component.html',
})
export class DepartmentListComponent extends PrimeNgTableVariablesModel implements OnInit {
  primengTableConfigProperties: any = {
    tableCaption: "Department",
    selectedTabIndex: 0,
    breadCrumbItems: [{ displayName: 'IT Management ' }, { displayName: 'Department List' }],
    tableComponentConfigs: {
      tabsList: [
        {
          caption: 'Department',
          dataKey: 'departmentId',
          enableAction: true,
          enableMultiDeleteActionBtn: true,
          enableStatusActiveAction: true,
          enableScrollable: true,
          checkBox: true,
          enableRowDelete: true,
          columns: [{ field: 'departmentName', header: 'Department Name' },
          { field: 'departmentCode', header: 'Department Code' },
          { field: 'description', header: 'Description' },
          { field: 'createdDate', header: 'Created Date', isDate: true },
          { field: 'isActive', header: 'Status' }
          ],
          apiSuffixModel: UserModuleApiSuffixModels.DEPARTMENTS,
          moduleName: ModulesBasedApiSuffix.IT_MANAGEMENT
        }]
    }
  }

  constructor(private dialog: MatDialog,
    private rxjsService: RxjsService,
    private store: Store<AppState>,
    private reusablePrimeNGTableFeatureService: ReusablePrimeNGTableFeatureService,
    public dialogService: DialogService,
    private snackbarService: SnackbarService,
    private crudService: CrudService) {
    super();
    this.primengTableConfigProperties = addDefaultTableObjectProperties(this.primengTableConfigProperties);
  }

  ngOnInit(): void {
    this.getDepartments();
    this.combineLatestNgrxStoreData();
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData),
      this.store.select(currentComponentPageBasedPermissionsSelector$)]
    ).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      let permission = response[1][IT_MANAGEMENT_COMPONENT.DEPARTMENT]
      if (permission) {
        let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigProperties, permission);
        this.primengTableConfigProperties = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
      }
    });
  }

  getDepartments(pageIndex?: string, pageSize?: string, otherParams?: object): void {
    this.loading = true;
    this.crudService.get(
      ModulesBasedApiSuffix.IT_MANAGEMENT,
      UserModuleApiSuffixModels.DEPARTMENTS,
      undefined,
      false,
      prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode === 200) {
        this.dataList = response.resources;
        this.totalRecords = response.totalCount;
        this.loading = false;
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  onCRUDRequested(type: CrudType | string, row?: object, searchObj?): void {
    switch (type) {
      case CrudType.CREATE:
        if (checkUserPermissionsByCategory.bind(this, CrudType.CREATE)) {
          this.openAddEditPage(CrudType.CREATE, row);
        }
        break;
      case CrudType.GET:
        this.getDepartments(
          row["pageIndex"], row["pageSize"], searchObj);
        break;
      case CrudType.VIEW:
        if (checkUserPermissionsByCategory.bind(this, CrudType.EDIT)) {
          this.openAddEditPage(CrudType.VIEW, row);
        }
        break;
      case CrudType.DELETE:
        if (checkUserPermissionsByCategory.bind(this, CrudType.DELETE)) {
          this.reusablePrimeNGTableFeatureService.openDynamicDeleteDialog(this.selectedTabIndex, this.selectedRows,
            this.primengTableConfigProperties, row)?.onClose?.subscribe((result) => {
              this.selectedRows = [];
              if (result) {
                this.getDepartments();
              }
            });
        }
        break;
      case CrudType.STATUS_POPUP:
        this.reusablePrimeNGTableFeatureService.openDynamicChangeStatusDialog(this.selectedTabIndex,
          this.primengTableConfigProperties, row)?.onClose?.subscribe((result) => {
            if (!result) {
              this.dataList[searchObj].isActive = this.dataList[searchObj].isActive ? false : true;
            }
          });
        break;
    }
  }

  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }

  onChangeSelecedRows(e) {
    this.selectedRows = e;
  }

  openAddEditPage(type: CrudType | string, divisionModel: DepartmentModel | any): void {
    let data = new DepartmentModel(divisionModel);
    const dialogReff1 = this.dialog.open(DepartmentAddEditComponent, { width: '450px', data, disableClose: true });
    dialogReff1.afterClosed().subscribe(result => {
      if (!result) return;
    });
    dialogReff1.componentInstance.outputData.subscribe(ele => {
      if (ele) {
        this.getDepartments();
      }
    });
  }
}
